import { Component, EventEmitter, Input, Output } from "@angular/core";
import * as XLSX from "xlsx";

@Component({
  selector: "app-download-excel-modal",
  templateUrl: "./download-excel-modal.component.html",
  styleUrls: ["./download-excel-modal.component.scss"],
})
export class DownloadExcelModalComponent {
  @Input() isOpen: boolean = false;
  @Input() fileType: string = "";
  @Output() closeModal = new EventEmitter<void>();

  downloadExcel(): void {
    let columnData = [];
    if (this.fileType === "BEGEOID") {
      columnData = [["BEGEOID"]];
    } else if (this.fileType === "END_CUSTOMER_ID") {
      columnData = [["END CUSTOMER GLOBAL HQ ID"]];
    } else if (this.fileType === "INDIVIDUAL_PRODUCT_LIST") {
      columnData = [["PRODUCT", "TYPE", "PAYOUT"]];
    } else if (this.fileType === "PRODUCT_LIST") {
      columnData = [["PRODUCT"]];
    } else if (this.fileType === "EXCEL_MERGE") {
      columnData = [["PRODUCT", "TYPE"]];
    } else if (this.fileType === "PRODUCT_SKUS") {
      columnData = [["PRODUCT SKUS"]];
    } else if (this.fileType === "PRODUCT_FAMILIES") {
      columnData = [["PRODUCT FAMILIES"]];
    } else if (this.fileType === "TARGETS_INDIVIDUAL") {
      columnData = [["USER", "TARGET"]];
    } else if (this.fileType === "TARGETS_COMPANY") {
      columnData = [["BEGEOID", "TARGET"]];
    } else if (this.fileType === "PARTICIPANT_INDIVIDUAL") {
      columnData = [["USERIDS"]];
    } else if (this.fileType === "PARTICIPANT_COMPANY") {
      columnData = [["BEGEOIDS"]];
    } else if (this.fileType === "UPLOAD_COMPLETION") {
      columnData = [["CCOID", "Date of completion (MM/DD/YYYY)"]];
    } else {
      return;
    }
    let workbook = XLSX.utils.book_new(),
      worksheet = XLSX.utils.aoa_to_sheet(columnData);
    workbook.SheetNames.push("First");
    workbook.Sheets["First"] = worksheet;
    let xlsbin = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    let buffer = new ArrayBuffer(xlsbin.length),
      array = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    let xlsblob = new Blob([buffer], { type: "application/octet-stream" });
    let url = window.URL.createObjectURL(xlsblob),
      anchor = document.createElement("a");
    anchor.href = url;
    if (this.fileType === "BEGEOID") {
      anchor.download = "BEGEOID_LIST.xlsx";
    } else if (this.fileType === "END_CUSTOMER_ID") {
      anchor.download = "END_CUSTOMER_LIST.xlsx";
    } else if (this.fileType === "INDIVIDUAL_PRODUCT_LIST") {
      anchor.download = "PRODUCT_PAYOUTS.xlsx";
    } else if (this.fileType === "PRODUCT_LIST") {
      anchor.download = "PRODUCT_LIST.xlsx";
    } else if (this.fileType === "EXCEL_MERGE") {
      anchor.download = "PRODUCT_LIST_ANY_PRODUCT.xlsx";
    } else if (this.fileType === "PRODUCT_SKUS") {
      anchor.download = "PRODUCT_SKUS.xlsx";
    } else if (this.fileType === "PRODUCT_FAMILIES") {
      anchor.download = "PRODUCT_FAMILIES.xlsx";
    } else if (this.fileType === "TARGETS_INDIVIDUAL") {
      anchor.download = "TARGETS_INDIVIDUAL.xlsx";
    } else if (this.fileType === "TARGETS_COMPANY") {
      anchor.download = "TARGETS_COMPANY.xlsx";
    } else if (this.fileType === "PARTICIPANT_INDIVIDUAL") {
      anchor.download = "PARTICIPANT_INDIVIDUAL.xlsx";
    } else if (this.fileType === "PARTICIPANT_COMPANY") {
      anchor.download = "PARTICIPANT_COMPANY.xlsx";
    } else if (this.fileType === "UPLOAD_COMPLETION") {
      anchor.download = "Participation Challenge Completions Upload.xlsx";
    }
    anchor.click();
    window.URL.revokeObjectURL(url);
  }
}
